/** Shared platform guard and stream cleanup for both Speaking preview and answer flows. */
export var isSpeakingRecorderSupported = function isSpeakingRecorderSupported() {
  var _navigator$mediaDevic;

  return typeof navigator !== 'undefined' && Boolean((_navigator$mediaDevic = navigator.mediaDevices) === null || _navigator$mediaDevic === void 0 ? void 0 : _navigator$mediaDevic.getUserMedia) && typeof MediaRecorder !== 'undefined';
};
/** Let each browser select the native format it can both record and play reliably. */

export var createSpeakingMediaRecorder = function createSpeakingMediaRecorder(stream) {
  return new MediaRecorder(stream);
};
/** Build a file extension from the actual media type, excluding codec parameters. */

export var getSpeakingAudioFileExtension = function getSpeakingAudioFileExtension(mimeType) {
  var mediaType = mimeType === null || mimeType === void 0 ? void 0 : mimeType.split(';', 1)[0].toLowerCase();

  switch (mediaType) {
    case 'audio/mp4':
    case 'video/mp4':
    case 'application/mp4':
      return 'mp4';

    case 'audio/ogg':
    case 'audio/oga':
      return 'ogg';

    case 'audio/mpeg':
    case 'audio/mp3':
      return 'mp3';

    case 'audio/wav':
    case 'audio/x-wav':
      return 'wav';

    case 'audio/webm':
      return 'webm';

    default:
      return mediaType !== null && mediaType !== void 0 && mediaType.startsWith('audio/') ? mediaType.slice('audio/'.length) : 'audio';
  }
};
export var stopSpeakingMediaStream = function stopSpeakingMediaStream(stream) {
  stream === null || stream === void 0 ? void 0 : stream.getTracks().forEach(function (track) {
    return track.stop();
  });
};